import Vue from "vue";
import VueRouter from "vue-router";

import Error4040View from "../view/pages/Error404.vue";
import ProfileView from "../view/pages/profile/profile.vue";

// Role
import RoleTemplateView from "../view/pages/role_template/Role.vue";
import RoleAsigmentView from "../view/pages/role_assigment/Role.vue";
import ApplicationSettingsView from "../view/pages/application_setting/Settings.vue"
import DMSPortalView from "../view/pages/application_setting/dmsportal"

import DashboardView from "../view/pages/dashboard/dashboard.vue";
import RoleManagementView from "../view/pages/role_management/Role.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: DashboardView,
  },
  {
    path: "/role-assignment",
    name: "RoleAssigment",
    component: RoleAsigmentView,
  },
  {
    path: "/application-settings",
    name: "ApplicationSetting",
    component: ApplicationSettingsView,
  },
  {
    path: "/dms-portal",
    name: "DMSPortal",
    component: DMSPortalView,
  },
  {
    path: "/role-management",
    name: "RoleManagement",
    component: RoleManagementView,
  },
  {
    path: "/role-template",
    name: "RoleTemplate",
    component: RoleTemplateView,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfileView,
  },
  {
    path: "*",
    name: "Error404",
    component: Error4040View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

//define route for handle authentication

// router.beforeEach((to, from, next) => {
//     let getStorage = localStorage.getItem('ugems-tokenParsed')
//     getStorage = JSON.parse(getStorage) || { data: {} }
//     if (to.meta.auth) {
//         if (getStorage.data.accessToken) {
//             return next()
//         } else {
//             return next('/login')
//         }
//     }
// })

export default router;
